<template>
  <div class="container">
    <van-search
      v-model="searchTheme"
      @search="onSearch"
      placeholder="搜索"
      left-icon="searchImg"
      shape="round"
    >
      <div slot="left-icon" class="searchImg">
        <img :src="searchImg" alt="" />
      </div>
    </van-search>
    <div class="teacher-list">
      <van-radio-group v-model="checked" @change="radioChange">
        <div v-for="(item, index) in listData" :key="index" class="m-b-35">
          <p class="subject" @click="isShowFun(item)">
            <img
              src="../teacherSchedule/img/triangle.png"
              :class="item.isShow ? '' : 'is-rotate'"
              alt=""
            />
            <span>{{ item.title }}</span>
          </p>
          <div class="name-list" v-if="item.isShow">
            <van-cell v-for="(item1, index1) in item.childrens">
              <van-radio checked-color="#2258e8" :name="item1">
                <img class="head" src="../teacherSchedule/img/head.png" alt="" />
                <span class="nowrap"> {{ item1.FullName }}（{{ item1.UserName }}） </span>
              </van-radio>
            </van-cell>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div class="sigle-bottom-btn">
      <van-button
        type="info"
        @click="clickBtn"
        round
        :loading="loading"
        :loading-text="loadingText"
        size="large"
      >
        确定
      </van-button>
    </div>
  </div>
</template>
<script>
import SingleBottomBtn from '@/components/SingleBottomBtn'
export default {
  components: {
    SingleBottomBtn
  },
  name: '',
  data() {
    return {
      loadingText: '加载中...',
      loading: false,
      searchTheme: '',
      listData: [],
      searchImg: require('../teacherSchedule/img/search.png'),
      checked: 1
    }
  },
  created() {
    this.getSchoole()
  },
  mounted() {},
  methods: {
    radioChange(val) {
      this.$store.commit('csmstimetable/setCurrentStudent', val)
    },
    clickBtn() {
      this.$router.push({
        path: '/home/studentSchedule'
      })
    },
    //获取学生
    async getSchoole() {
      this.xy.loading()
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          '/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableStudentOrgList',
        {
          ApplicationID: this.$store.state.common.menuIDs[1],
          StudentGradeID: this.$store.state.csmstimetable.studentVal.classVal.value,
          SchoolDistrictID: this.$store.state.csmstimetable.studentVal.schooleVal.value
        }
      )
      this.xy.unloading()
      if (res.success) {
        this.listData = res.data.map(item => {
          return {
            title: item.FullName,
            StudentGradeForStudentYearID: item.StudentGradeForStudentYearID,
            StudentOrganizationID: item.StudentOrganizationID,
            isShow: false,
            childrens: item.Member
          }
        })
        this.listDataCopy = this.listData
      } else {
        this.$toast.fail(res.data)
      }
    },
    onSearch() {
      let searchData = JSON.parse(JSON.stringify(this.listDataCopy))
      console.log(searchData)
      searchData.forEach(item => {
        item.childrens = item.childrens.filter(
          ele =>
            ele.UserName.indexOf(this.searchTheme) != -1 ||
            ele.FullName.indexOf(this.searchTheme) != -1
        )
      })
      searchData = searchData.filter(e => e.childrens.length)
      this.listData = searchData
    },
    isShowFun(item) {
      item.isShow = !item.isShow
    },
    complete() {}
  }
}
</script>
<style lang="less" scoped>
// 我的样式
.searchImg {
  width: 32px;
  height: 32px;
  position: relative;
  img {
    width: 32px;
    height: 32px;
    left: 0;
    top: 0;
  }
}
.teacher-list {
  padding: 24px 29px;
  padding-bottom: 120px;
  .m-b-35 {
    margin-bottom: 35px;
  }
  p.subject {
    display: flex;
    align-items: center;
    .is-rotate {
      transform: rotate(-90deg);
    }
    img {
      width: 15px;
      height: 13px;
    }
    span {
      margin-left: 9px;
      color: #666666;
    }
  }
  .name-list {
    margin-top: 10px;
    .head {
      width: 60px;
      height: 60px;
      margin-left: 10px;
    }
    .van-cell {
    }
  }
}
.sigle-bottom-btn {
  height: 128px;
  line-height: 128px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 50px;
  .van-button--info {
    color: #fff;
    background-color: #2258e8;
    border: 1px solid #2258e8;
  }
  .van-button--large {
    height: 35px !important;
    line-height: 35px !important;
  }
}
.container {
  position: relative;
  background: #fff;
  min-height: 100vh;
}
</style>
